export const defaultEqual = (oldValue, newValue) => oldValue === newValue;
